import { makeStyles } from '@material-ui/core'
import pluralize from 'pluralize'
import React from 'react'

import { Typography } from 'src/modules/ui'
import { useIsMobile } from 'src/modules/ui/utils'
import { formatPrice } from 'src/utils'

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  orderBar: {
    backgroundColor: theme.palette.lightGreen.main,
    bottom: 0,
    left: 0,
    padding: theme.spacing(1, 2, 2),
    position: 'fixed',
    right: 0,
    zIndex: 10,
    [theme.breakpoints.up('mobile')]: {
      padding: theme.spacing(3, 2),
    },
  },
  orderBarInner: {
    gap: theme.spacing(0.5),
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    maxWidth: theme.maxWidth,
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      gap: theme.spacing(1),
    },
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      gap: '0px',
    },
  },
  orderNumProducts: {
    color: 'white',
    fontFamily: 'Gotham',
    marginLeft: theme.spacing(2),
  },
  orderTotal: {
    color: 'white',
    fontFamily: 'Gotham',
    fontSize: '1.25rem',
    fontWeight: 500,
  },
}))

const TotalBar = ({ children, numProducts, numSuppliers, total }) => {
  const classes = useStyles()
  const isMobile = useIsMobile()

  return (
    <div className={classes.orderBar}>
      <div className={classes.orderBarInner}>
        <Typography className={classes.orderTotal}>
          {formatPrice(total)}
        </Typography>
        {!isMobile && (
          <Typography className={classes.orderNumProducts}>
            {pluralize('product', numProducts, true)} from{` `}
            {pluralize('supplier', numSuppliers, true)}
          </Typography>
        )}
        <div className={classes.grow} />
        {children}
      </div>
    </div>
  )
}

export default TotalBar
